import {request} from '@/util/scripts/request'
import {localStorage} from '@/util/scripts/local-storage'
import '@/util/scripts/promise'

const forceInterval = function (handler, delay = 100) {
  let handle
  return () => {
    clearTimeout(handle)
    handle = setTimeout(handler, delay)
  }
}

export default {
  install(Vue) {
    Vue.prototype.localStorage = localStorage
    Vue.prototype.forceInterval = forceInterval
    let dispatcher = Vue.prototype.dispatcher = new Vue()
    if (!window.resizeHandler) {
      window.resizeHandler = forceInterval(() => dispatcher.$emit('resize', {type: 'window'}), 200)
      window.addEventListener('resize', window.resizeHandler)
    }
    if (!window.scrollHandler) {
      window.scrollHandler = () => dispatcher.$emit('scroll', {top: $('body,html').scrollTop(), left: $('body,html').scrollLeft()})
      window.addEventListener('scroll', window.scrollHandler)
    }
    Vue.prototype.listenDomEvent = function (flag) {
      if (flag) {
        if (this.handleResize) dispatcher.$on('resize', this.handleResize)
        if (this.handleScroll) dispatcher.$on('scroll', this.handleScroll)
      } else {
        if (this.handleResize) dispatcher.$off('resize', this.handleResize)
        if (this.handleScroll) dispatcher.$off('scroll', this.handleScroll)
      }
    }
    //
    Vue.prototype.request = function ({
                                        action, service, params, pagination,
                                        success, error, finished, cancel,
                                        confirm, prompt, notifySuccessTitle, notifyErrorTitle, loading = true
                                      }) {
      let actionFunc = (_prompt) => {
        if (loading) this.loading = true
        if (service) action = (_prompt) => request(service, Object.assign({_prompt}, params), pagination)
        action(_prompt).then((data) => {
          if (data.success) {
            let {result, message} = data
            if (success) success(result, data)
            if (notifySuccessTitle) this.$notify({title: notifySuccessTitle, message, type: 'success'})
          } else {
            // throw data
            if (error) error(data)
            if (notifyErrorTitle) this.$notify({title: notifyErrorTitle, message: data.message, type: 'error'})
          }
          return data
        }).catch(e => {
          if (e.response || e.request || e.message === 'Network Error') {
            if (e.message === 'Network Error') e.message = '接口请求失败,数据未正常返回'
            if (error) error({success: false, message: e.toString()})
            if (notifyErrorTitle) this.$notify({title: notifyErrorTitle, message: e.toString(), type: 'error'})
          } else console.error(e)//本地环境时将输出前端错误
        }).finally(() => {
          if (loading) this.loading = false
          if (finished) finished()
        })
      }
      if (confirm) {
        let options = isObject(confirm) ? confirm : {message: confirm}
        if (!options.hasOwnProperty('title')) options.title = '提示'
        this.$confirm(options.message, options).then(actionFunc).catch(cancel ? cancel : e => '')
      } else if (prompt) {
        this.$prompt(prompt.message, prompt).then(actionFunc).catch(cancel ? cancel : e => '')
      } else actionFunc()
    }
  }
}

